// Polyfill para process.env en desarrollo
if (typeof process === 'undefined') {
  window.process = { env: {} };
}

const ORDER_TAKER_TENANTS = (process.env.REACT_APP_ORDER_TAKER_TENANTS || '').split(',').map((t) => t.trim());

export default function isOrderTakerEnabled(tenant) {
  return ORDER_TAKER_TENANTS.includes((tenant || '').trim());
}

// Función para obtener el tenant desde el estado de Redux
export function getTenantFromState(state) {
  return state.core.tenant;
}

// Función que combina obtener tenant y verificar si está habilitado
export function isOrderTakerEnabledFromState(state) {
  const tenant = getTenantFromState(state);
  return isOrderTakerEnabled(tenant);
}
